var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layer", { staticClass: "layer_posi", attrs: { name: "edit" } }, [
    _c("div", { staticClass: "wrap_layer_g layer_edit" }, [
      _c("strong", { staticClass: "layer_tit" }, [_vm._v("말머리/제목 편집")]),
      _vm._v(" "),
      _c("p", { staticClass: "info_addition" }, [
        _vm._v("말머리와 제목 스타일을 편집할 수 있습니다."),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "edit_kind" }, [
        _c("div", { staticClass: "division_edit" }, [
          _c(
            "div",
            {
              staticClass: "opt_selected_g opt_preface",
              class: _vm.headContClass,
            },
            [
              _c("strong", { staticClass: "screen_out" }, [
                _vm._v("검색 옵션 선택상자"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "opt_tit" }, [
                _c(
                  "a",
                  {
                    staticClass: "tf_opt",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleHeadContLayer.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "txt_selected" }, [
                      _vm._v(_vm._s(_vm.selectedHeadCont || "말머리 없음")),
                      _c("span", { staticClass: "screen_out" }, [
                        _vm._v("선택됨"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ico_bbs ico_arrow" }, [
                      _vm._v("옵션 더 보기"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.headContLayerOpen,
                      expression: "headContLayerOpen",
                    },
                  ],
                  staticClass: "box_opt_menu",
                },
                [
                  _c(
                    "div",
                    { staticClass: "inner_menu" },
                    [
                      _c("div", { staticClass: "menu_item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "link_menu",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.selectHeadCont("")
                              },
                            },
                          },
                          [_vm._v(_vm._s("말머리 없음"))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.headConts, function (headCont) {
                        return _c("div", { staticClass: "menu_item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "link_menu",
                              attrs: { href: "javascript:" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.selectHeadCont(headCont)
                                },
                              },
                            },
                            [_vm._v(_vm._s(headCont))]
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "menu_add" }, [
                    _c("input", {
                      staticClass: "inp_add",
                      attrs: {
                        id: "head-cont-add-input",
                        type: "text",
                        placeholder: "말머리 추가",
                      },
                      domProps: { value: _vm.newHeadCont },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                        input: _vm.onHeadContInput,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn_g_ico btn_plus",
                        attrs: { id: "head-cont-add-btn", type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm._addHeadCont.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "ico_bbs ico_plus" }, [
                          _vm._v("머리말 추가하기"),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "division_edit" }, [
          _c("div", { staticClass: "text_edit_bold" }, [
            _c(
              "button",
              {
                staticClass: "btn_g_ico btn_edit_font",
                class: { ico_on: _vm.bold },
                attrs: { id: "title-bold-btn", type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleBold.apply(null, arguments)
                  },
                },
              },
              [
                _c("span", { staticClass: "ico_bbs ico_text_bold" }, [
                  _vm._v(
                    _vm._s(_vm.bold ? "텍스트 얇게하기" : "텍스트 굵게하기")
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text_edit_color", class: _vm.colorLayerClass },
            [
              _c(
                "button",
                {
                  staticClass: "btn_g_ico btn_edit_font",
                  class: { ico_on: _vm.colorLayerOpen },
                  attrs: { id: "title-color-btn", type: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleColorLayer.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "ico_bbs ico_text_color" }, [
                    _vm._v("텍스트 색상바꾸기"),
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "color_selected",
                    style: { backgroundColor: _vm.selectedColor },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "layer_color" }, [
                _c("span", { staticClass: "ico_bbs ico_editor_arrow" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "list_color" },
                  [
                    _c("div", { staticClass: "color_item" }, [
                      _c(
                        "button",
                        {
                          staticClass: "color_circle btn_g_ico",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectColor("")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "ico_bbs ico_none" }, [
                            _vm._v("기본색상"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.colors, function (color) {
                      return _c(
                        "div",
                        {
                          staticClass: "color_item",
                          class: { on_check: _vm.selectedColor === color },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "color_circle btn_g_ico",
                              class: _vm.colorItemClass(color),
                              style: _vm.colorItemStyle(color),
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.selectColor(color)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "screen_out" }, [
                                _vm._v("컬러코드 " + _vm._s(color)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "ico_bbs ico_selected" },
                                [_vm._v("선택됨")]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "box_info" }, [
                  _c(
                    "div",
                    {
                      staticClass: "color_info",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("span", {
                        ref: "colorCircle",
                        staticClass: "color_circle",
                        style: _vm.colorCircleStyle,
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "txt_color" }, [
                        _c("span", { staticClass: "txt_item" }, [_vm._v("#")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputColor,
                              expression: "inputColor",
                            },
                          ],
                          staticClass: "txt_inp",
                          attrs: {
                            id: "title-color-input",
                            maxlength: "6",
                            pattern: "[0-9a-fA-F]{3,6}",
                            type: "text",
                            placeholder: "000000",
                          },
                          domProps: { value: _vm.inputColor },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.inputColor = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn_input",
                      attrs: { id: "title-color-input-btn", type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.selectInputColor.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("입력")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layer_btn area_btn_g" }, [
        _c("div", { staticClass: "area_r" }, [
          _c(
            "button",
            {
              staticClass: "btn_g type3",
              attrs: { id: "title-cancel-btn", type: "button" },
            },
            [_vm._v("취소")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn_g type4",
              attrs: { id: "title-confirm-btn", type: "button" },
              on: { click: _vm.editTitle },
            },
            [_vm._v("확인")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }